import ReactDOM from 'react-dom/client'

import '@/shared/styles/global.css'

import App from './app/app.tsx'
import { LiffSDK } from '@/modules/game/shared/lib/sdk/liff.ts'
import { initializeWallet } from '@/modules/game/shared/lib/sdk/dapp-portal'
import { initializeWagmiConfig, initializeWagmiConfigWithDappPortal } from '@/app/providers/wagmi'
import { isGameLocation } from '@/shared/lib/utils/location.ts'
import i18n from '@/app/i18n.ts'

function render() {
  return ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
}

if (isGameLocation()) {
  LiffSDK.init()
    .then(async () => {
      await initializeWallet()
      await initializeWagmiConfigWithDappPortal()
    })
    .catch(async () => {
      await initializeWagmiConfig()
    })
    .finally(async () => {
      const language = LiffSDK.getLanguage()
      await i18n.changeLanguage(language === 'ja' ? 'ja' : 'en')

      render()
    })
} else {
  initializeWagmiConfig().finally(() => render())
}
